import {Component, Input, OnInit} from '@angular/core';
import {StepsService} from "../../services/steps.service";
import {environment} from "../../../environments/environment";
import {ChoiceService} from "../../services/choice.service";
import {Device} from "../../models/device.model";

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {
    step = 1;
    imgUrl = environment.serverImages
    choice: string;
    selectedDevice: Device
    constructor(private stepSrv: StepsService, private choiceSrv: ChoiceService) {
    }

    ngOnInit(): void {


        this.stepSrv.step$.subscribe(step => {
            this.step = step;
        })
        this.choiceSrv.choice$.subscribe(choice => {
            this.choice = choice;
        })
        this.choiceSrv.selectedDevice$.subscribe(device => {
            this.selectedDevice = device;
        })


    }

    setStep(stepNumber: number) {

        this.stepSrv.setStep(stepNumber)
    }


}
